var ReifendirektCallBackRequestAddOnJs = (function ($) {
    var messageSending = null;
    var messageSuccess = null;
    var messageError = null;
    var reCaptchaContent = null;

    var initDateAndTimePickers = function() {
        $('#contactTime .time').timepicker({
            'showDuration': false,
            'timeFormat': 'g:ia',
            'minTime': '9:00am',
            'maxTime': '6:00pm',
            'disableTextInput': true
        });
        $('#contactTime').datepair();

        $('#contactTime .date').datepicker({
            minDate: new Date(),
            dateFormat: "dd/mm/yy"
        });
    };

    var submitFormEvent = function(callBackFunctionClass, callBackSubmitButtonClass) {
        $(document).on("click", callBackSubmitButtonClass, function () {
            if (ReifendirektCaptchaAddOnJs.isInvisibleCaptchaEnabled()) {
                ReifendirektCaptchaAddOnJs.executeRecaptcha('callback_recaptcha');
            } else{
               submitForm(callBackFunctionClass);
            }
        });
    };

    var submitForm = function(callBackFunctionClass) {
        messageSending = $("input[name='messageSending']").val() === undefined ? "Sending..." : $("input[name='messageSending']").val();
        messageSuccess = $("input[name='messageSuccess']").val() === undefined ? "Success" : $("input[name='messageSuccess']").val();
        messageError = $("input[name='messageError']").val() === undefined ? "Error!" : $("input[name='messageError']").val();

        initOverlaySpinner(messageSending);
        var form = $(callBackFunctionClass);

        ajaxCall('POST', form.attr('action'), form.serialize(), function (data) {
            if (containsErrors(data)) {
                form.parent().html(data);
                initDateAndTimePickers();
                messageOverlay.showError(messageError);
            } else {
                if (typeof gtmCallbackRequestSent === "function") {
                    gtmCallbackRequestSent();
                }
                $.fancybox.close();
                messageOverlay.showSuccess(messageSuccess);
                $(".errorMessage.captcha-error-message-container").hide();
            }
            messageOverlay.hideSlow();
        });
    };

    var submitCallBackForm = function () {
        submitForm('.j-call-back-function');
    }

    var containsErrors = function (text) {
        var responseText = String(text);
        return responseText
                    && (responseText.length > 0)
                    && ($(responseText).find("div.j-errors-on-page").length > 0
                            || $(responseText).find("div.errorMessage").length > 0);
    };

    var initActions = function(callBackContainerClass, callBackFunctionClass, callBackSubmitButtonClass) {
        initDateAndTimePickers();
        $(callBackContainerClass).on("click", function () {
            var $this = $(this);
            ajaxCall("GET", $this.data("request-attribute"), null, function (data) {
                if (data.indexOf("<!DOCTYPE html>") == -1) {
                    reCaptchaSave();
                    $.fancybox(data, {
                        fitToView: true,
                        width: 500,
                        height: 'auto',
                        autoSize: false,
                        closeClick: false,
                        openEffect: 'none',
                        afterShow: function() {
                            initDateAndTimePickers();
                        },
                        closeEffect: 'none',
                        helpers : {
                            overlay: {
                                locked: true
                            }
                        },
                        afterClose: reCaptchaRestore
                    });
                } else {
                    var baseUrl = $this.data("base-url");
                    window.location.href = baseUrl + 'call-back-request';
                }
            });
        });

        submitFormEvent(callBackFunctionClass, callBackSubmitButtonClass);
    };

    var ajaxCall = function (type, url, callData, successCallback) {
        $.ajax({
            type: type,
            url: url,
            data: callData
        }).done(function (data, status, xhr) {
            if (successCallback) {
                successCallback(data);
            }
        }).fail(function (xhr, status, error) {
            messageOverlay.showError(messageError);
            messageOverlay.hideSlow();
        });
    };

    var reCaptchaSave = function () {
        var reCaptchaSelector = $('#recaptcha_container_callback');
        if (reCaptchaSelector.length > 0) {
            $(".g-recaptcha").empty();
            reCaptchaContent = reCaptchaSelector.html();
            reCaptchaSelector.empty();
        }
    };

    var reCaptchaRestore = function () {
        if (reCaptchaContent && reCaptchaContent.length > 0 && $("#recaptcha_container_callback").length > 0) {
            $("#recaptcha_container_callback").html(reCaptchaContent);
            reCaptchaContent = null;
        }
    };

    return {
        initActions: initActions,
        submitCallBackForm: submitCallBackForm
    };

})(jQuery);

$(document).ready(function() {

    ReifendirektCallBackRequestAddOnJs.initActions('.j-call-back', '.j-call-back-function', '.j-call-back-send');

});